import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m13.9 13.4 3.5 3.5M1.6 8.1c0 1.9.8 3.7 2.1 5s3.1 2 4.9 2c1.9 0 3.7-.7 5-2s2-3.1 2-5c0-1.8-.7-3.6-2-4.9s-3.1-2.1-5-2.1c-1.8 0-3.6.8-4.9 2.1S1.6 6.3 1.6 8.1",
      style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }